/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import {getSelectedProductIdFromActionInput,getSimpleProductsAction,ProductInput } from '@msdyn365-commerce-modules/retail-actions';

import { IAny, ICreateActionContext, IGeneric } from '@msdyn365-commerce/core';
import { getProductETAInfoAsync } from './getProductETADetails';
// import { ProductInput } from './inputs/product-input';
/**
 * ProductEtaAction Input Action
 */
export class ProductEtaActionInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public productId: number;

    public channelId: number;

    public config: any;

    constructor(productId: number, channelId: number, config: any) {
        this.channelId = channelId;
        this.productId = productId;
        this.config = config;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `${this.channelId}-${this.productId}`;
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IProductEtaActionData {
    etaObj: any;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
export const createGetProductEtaInput = (inputData: ICreateActionContext<IGeneric<IAny>>): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);
    if(productId)
    {
        return new ProductEtaActionInput(+productId, +inputData.requestContext.apiSettings.channelId, inputData.config);

    }
    throw new Error('Unable to create SelectedVariantInput, no productId found on module config or query');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getProductEtaAction(input: ProductEtaActionInput, ctx: Msdyn365.IActionContext): Promise<IProductEtaActionData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;
   const prod:ProductInput[] = new Array();
   prod.push(new ProductInput(input.productId,ctx.requestContext.apiSettings));
    var prodDtl = await getSimpleProductsAction(prod,ctx);
    const prodEta = await getProductETAInfoAsync({callerContext: ctx, bypassCache: 'get'},ctx,prodDtl[0].ItemId!);
    return { etaObj: prodEta };
}

export const getProductEtaActionDataAction = Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IProductEtaActionData>>getProductEtaAction,
    // TODO: Give your data action a unique id
    id: 'ProductEtaAction',
    input: createGetProductEtaInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});

export default getProductEtaActionDataAction;